/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

window.slick = require('slick-carousel');


;$(function() {

    $('.slider').slick({
        infinite: true,
        autoplay: true,
        dots: false,
        arrows: false,
        speed: 1000,
    });

});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 3
// module chunks = 0